import React, { useState } from 'react';
import { Layout } from 'antd';
import InventorySidebar from '../components/Layout/InventorySidebar';
import TopHeader from '../components/Layout/TopHeader';
import { Outlet } from 'react-router-dom';

const { Content } = Layout;

const InventoryLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = () => setCollapsed(!collapsed);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <InventorySidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <Layout>
        <TopHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />
        <Content style={{ margin: 16, padding: 16, background: '#fff', minHeight: 280 }}>
             <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default InventoryLayout;
